import React, { useCallback, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { formChange } from '../reducers/form'
import * as actions from '../reducers/autocomplite'
import AutocompliteMUI from './AutocompliteMUI';

const EMPTY_OBJECT = {}
/**
 * @typedef {Object} Option
 * @property {string | number} value - Уникальный идентификатор опции.
 * @property {string} label - Отображаемый текст опции.
 * @property {any} [key] - Любые дополнительные скрытые поля (например, из meta.hidden).
 */
/**
 * @type {Option[]}
 */
const EMPTY_ARRAY = [];
/**
 * @typedef {Object} AutocompleteOption
 * @property {string|number} value - Уникальный идентификатор опции.
 * @property {string} label - Отображаемый текст опции.
 * @property {any} [key] - Любые дополнительные скрытые поля (например, из meta.hidden).
 */
/**
 * @typedef {import('@mui/material').AutocompleteProps<string, false, false, false>} MUIAutocompleteProps
 * 
 * @function AutocompliteMUILoad
 * @param {Object} props - Пропсы компонента.
 * @param {string} props.field - Имя поля в стейте form
 * @param {string} props.placeHolder - Текст лейбла для поля ввода (используется как label в TextField).
 * @param {string} props.path - URL-адрес эндпоинта для запроса 
 * @param {Object} props.meta - Конфигурация обработки данных и привязки к стейту.
 * @param {string} props.meta.field - Имя поля в стейте autocomplite.
 * @param {string} props.meta.value - Ключ в объекте ответа, который будет использован как `value` опции.
 * @param {string} [props.meta.label] - Ключ в объекте ответа, который будет использован как `label` опции.
 * @param {Function} [props.meta.labelFunc] - Функция для генерации `label`, если `meta.label` не указан. Принимает исходный объект.
 * @param {string[]} [props.meta.hidden] - Массив ключей, значения которых нужно сохранить в объекте опции (скрытые данные).
 * @param {Function} [props.meta.filter] - Функция для фильтрации сырого массива данных ДО передачи в редьюсер. Принимает массив, возвращает массив.
 * @param {any} [props.meta.defaultValue] - Значение по умолчанию, которое будет выбрано в автокомплите после загрузки (должно совпадать с будущим `value`).
 * @param {boolean} [props.form] -  сохраняем в стейте store.form  default true
 * @param {string} [props.formName] -  позиция в стейте form store.form[name] 
 * @param {Function} [props.change] -  доп функция для изменения 
 * @param {Object|Object[]} [props.initialValue] -  начальное значение потом убрать можно
 * @param {React.ComponentProps<typeof TextField>} [props.textFieldProps]
 * @param {Omit<import('@mui/material').AutocompleteProps<AutocompleteOption, boolean, boolean, boolean>, 'options' | 'value' | 'onChange' | 'renderInput'>} [props.autocompleteProps] - 
 */
export default function AutocompliteMUILoad({
  field,
  placeHolder,
  path,
  meta,
  change,
  form = true,
  formName,
  initialValue,
  textFieldProps = EMPTY_OBJECT,
  autocompleteProps = EMPTY_OBJECT
}) {
  const dispatch = useDispatch()
  const autoValue = useSelector(state => state.autocomplite[meta.field]?.value || null)
  const autoArr = useSelector(state => state.autocomplite[meta.field]?.arr) || EMPTY_ARRAY
  const autoLoad = useSelector(state => state.autocomplite[meta.field]?.load || false)

  useEffect(() => {
    dispatch(actions.initialAutocomplite({ field: meta.field, value: initialValue }))
    return () => {
      dispatch(actions.clearAutocomplite({ field: meta.field }))
    }
  }, [dispatch, meta.field, initialValue])
  useEffect(() => {
    if (autoLoad) return;
    dispatch(actions.loadAutocompliteAPI(path, meta))
  }, [dispatch, path, meta, autoLoad])
  const handleChange = useCallback((e) => {
    const value = (e) ? e.value : null
    dispatch(actions.set(e, { field: meta.field }))
    if (form) dispatch(formChange(value, { field: field, name: formName }))
    if (change) change(e)
  }, [dispatch, change, formName, field, form, meta.field])

  // жуткий костыль. подумать как исправить потом obj.value may be arr, object, null
  const valueM = (!autoValue) ? [] : (autoValue.length >= 0) ? autoValue : [autoValue]
  // костыль 
  const valueNUll = autoValue?.value === '' ? null : autoValue
  return <AutocompliteMUI
    options={autoArr}
    action={handleChange}
    placeHolder={placeHolder}
    value={(autocompleteProps.multiple) ? valueM.filter(e => e.value !== '') : valueNUll}
    textFieldProps={textFieldProps}
    autocompleteProps={autocompleteProps}
  />
}